import { render } from "./ClientAiChat.vue?vue&type=template&id=78946ca8&scoped=true"
import script from "./ClientAiChat.vue?vue&type=script&lang=js"
export * from "./ClientAiChat.vue?vue&type=script&lang=js"

import "./ClientAiChat.vue?vue&type=style&index=0&id=78946ca8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78946ca8"]])

export default __exports__